import services from 'services/module';

export class WistiaSvc {
    private baseUrl    = 'https://api.wistia.com/v1/';
    private baseParams = {
        api_password: options.wistiaApiKey,
    };

    constructor(private $q: ng.IQService,
                private $http: ng.IHttpService) {
    }

    getWistiaPlayer(wistiaId: string, options = {}) {
        const deferred  = this.$q.defer();
        let videoPlayer = window.Wistia && window.Wistia.api(wistiaId);

        if (videoPlayer) {
            const waitForPlayer = () => setTimeout(() => {
                videoPlayer = window.Wistia.api(wistiaId);

                if (videoPlayer.ready()) {
                    deferred.resolve(videoPlayer)
                } else {
                    waitForPlayer();
                }
            }, 100);
            waitForPlayer();
        } else {
            window._wq = window._wq || [];
            window._wq.push({
                id: wistiaId,
                options: {
                    videoFoam: true,
                    ...options
                },
                onReady(videoPlayer: any) {
                    deferred.resolve(videoPlayer)
                }
            });
        }

        return deferred.promise;
    }

    getMedia(id: string): ng.IPromise<anm.WistiaMedia> {
        const url = `${this.baseUrl}medias/${id}.json`;
        return this.$http
            .get<anm.WistiaMedia>(url, {
                params: this.baseParams
            })
            .then(r => r.data);
    }
}

services.service('wistiaSvc', WistiaSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/WistiaSvc.ts